<template>
  <div>
    <t-blackout v-model="blackoutWebcam" @onClose="closeWebcam">

      <template #buttons-top>

        <b-row class="d-flex align-content-center justify-content-center p-2">

          <b-button variant="primary" class="mr-2" v-if="!isPhotoTaken" @click="takePhoto">
            <b-icon-image-fill/>
            Capturar foto
          </b-button>

          <div v-show="isPhotoTaken">

            <b-button variant="secondary" class="mr-2" @click="openWebcam(false)">
              <b-icon-image-fill/>
              Tirar outra
            </b-button>

            <b-button variant="primary" class="mr-2" @click="sendPhoto">
              <b-icon-check-circle-fill/>
              Confirmar e salvar imagem
            </b-button>

          </div>


          <b-button variant="danger" @click="closeWebcam">
            <b-icon-box-arrow-in-down-left/>
            Fechar
          </b-button>

        </b-row>

      </template>

      <div>

        <b-row class=" m-0">


          <div style="max-width: 800px; height: 600px">

            <div v-show="isFlashPhoto"
                 style="width: 800px; height: 600px; left: 0; top:0; background-color: #FFFFFF; opacity: 0.7"></div>


            <video ref="camera" :id="'web-cam-upload-files-video-'+complementId" v-show="!isPhotoTaken && !isFlashPhoto"
                   width="800"
                   height="600"
                   style="background-color:#E7E7E7; width:100%" autoplay></video>

            <canvas ref="canvas" :id="'web-cam-upload-files-canvas-'+complementId"
                    v-show="isPhotoTaken && !isFlashPhoto" width="1200"
                    height="900"
                    style="background-color:#E7E7E7; display:none; width: 100%"></canvas>


          </div>


        </b-row>

      </div>

    </t-blackout>

    <transition name="fade">

      <div v-if="progressInfos">
        <div class="mb-2"
             v-for="(progressInfo, index) in progressInfos.filter((a) => {return 'fileName' in a})"
             :key="index"
        >
          <div>

          <span v-if="progressInfo.error !== ''" class="alert-danger">
            {{ progressInfo.fileName }} - {{ progressInfo.error }}
          </span>
            <span v-else>{{ progressInfo.fileName }}</span>
            <div class="progress">
              <div class="progress-bar progress-bar-info"
                   role="progressbar"
                   :aria-valuenow="progressInfo.percentage"
                   aria-valuemin="0"
                   aria-valuemax="100"
                   :style="{ width: progressInfo.percentage + '%' }"
              >
                {{ progressInfo.percentage }}%
              </div>
            </div>

          </div>

        </div>
      </div>

    </transition>

    <div class="d-flex justify-content-start align-items-center">

      <label class="btn btn-default">

        <b-form-file
            :disabled="status === 'sending'"
            class="col-12 input-upload-files"
            :id="'form-input-send-files-'+complementId"
            ref="formInputFile"
            :value="filesSelected"
            @change="selectFile"
            @keyup.enter.prevent
            @keydown.enter.prevent
            capture
            :multiple="categoryUnique === ''"
            placeholder="Arraste para aqui se preferir"
        ></b-form-file>

        <div v-if="showMessageSelectFiles">
          <b-tooltip placement="bottom" show ref="tooltip" target="form-input-send-files"
                     title="Selecione pelo menos 1 arquivo"></b-tooltip>
        </div>


      </label>

      <t-button :sending="status === 'sending'" :text="buttonText" @click="uploadFiles(false)" no-icon submit-fake/>
      <t-button v-if="typeImage && !disableWebcam" :sending="status === 'sending'" text="Utilizar webcam"
                @click="openWebcam(true)"
                class="ml-2">
        <b-icon-camera/>
        Webcam
      </t-button>

      <t-button v-if="typeImage" :sending="status === 'sending'" v-show="qtyTotal > 0" @click="onDownloadAllFiles()"
                class="ml-2">
        <b-icon-arrow-down-circle/>
        Download Todas
      </t-button>


      <transition name="fade">
        <t-msg v-if="uploadSuccess" class="ml-3 mt-3" :query="{codSuccess:1}" title="Arquivos" auto-hide plural/>
      </transition>


    </div>


  </div>
</template>
<script>
import http from "@/services/config/http-common"
import ui from "@/assets/scripts/ui"

export default {
  name: "t-upload-files",
  data() {
    return {
      selectedFiles: undefined,
      status: String,
      buttonText: "",
      hasError: false,
      uploadSuccess: false,
      showMessageSelectFiles: false,
      blackoutWebcam: false,
      isPhotoTaken: false,
      isFlashPhoto: false,
      filesSelected: [],
      progressInfos: [],
      message: "",
      fileInfos: [],
      listSend: [],
      slice_size: 500000,
      maxFilesSend: 500,
      sizeMaxAcceptedKb: 0,
      complementId: "",
      byWebcam: "",//Armazena para quando utilizar formulários especiais
      typeImage: Boolean,
      extensionAccepted: []
    }
  },
  props: {
    maxSizeKB: {
      type: Number,
      default: 0,
    },
    disableWebcam: Boolean,
    continuedSubmit: Boolean,
    specialTypeEvidenceFile: Boolean,
    evidenceFileEntity: Object,
    qtyTotal: {
      type: Number,
      default: 0,
    },
    extension: [],
    type: {
      type: String,
      default: ""
    },
    foreignKey: {
      type: Number,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: ""
    },
    categoryUnique: {
      type: String,
      default: ""
    },
    detailUnique: {
      type: String,
      default: ""
    },
    categoryId: {
      type: Number,
      default: 0
    },
    otherForeignKey: {
      type: Number,
      default: 0
    },
  },
  methods: {

    closeWebcam() {

      if (this.$refs.camera && this.$refs.camera.srcObject) {

        let tracks = this.$refs.camera.srcObject.getTracks()

        tracks.forEach(track => {
          track.stop()
        })

      }

      this.blackoutWebcam = false
      this.isPhotoTaken = false
      this.isFlashPhoto = false

    },

    takePhoto() {

      if (!this.isPhotoTaken) {

        this.isFlashPhoto = true

        setTimeout(() => {
          this.isFlashPhoto = false
        }, 100);


      }

      this.isPhotoTaken = !this.isPhotoTaken
      const context = this.$refs.canvas.getContext('2d')
      context.drawImage(this.$refs.camera, 0, 0, 1200, 900)

    },

    sendPhoto() {

      const canvas = document.getElementById("web-cam-upload-files-canvas-" + this.complementId).toDataURL("image/jpeg")

      let newArrayValid = [{name: "image_by_webcam.jpg", size: canvas.length, type: "image/jpeg", content: canvas}]

      this.selectedFiles = newArrayValid

      this.closeWebcam()
      this.uploadFiles(true)

    },

    async onDownloadAllFiles() {

      this.$emit("onDownloadAllFiles")

    },

    async openWebcam(blackoutWebcam) {

      this.isPhotoTaken = false
      this.isFlashPhoto = false

      if (blackoutWebcam)
        this.blackoutWebcam = true


      navigator.mediaDevices
          .getUserMedia({video: true, audio: false})
          .then((stream) => {
            this.$refs.camera.srcObject = stream
          })
          .catch(error => {
            ui.msgError(this, 'Erro ao tentar iniciar webcam: ' + error + ' - Obs.: Verique se a webcam está instalda no PC e não está sendo usada por outro programa ou navegador no momento. Para tentar corrigir o problema tente desconectar o plug USB e ligar novamente.', () => {
              this.closeWebcam()
            })
          })

    },

    selectFile(event) {
      this.showMessageSelectFiles = false
      this.progressInfos = []
      this.hasError = false

      let fileList = []

      // Detectar a origem dos arquivos
      if (event.dataTransfer && event.dataTransfer.files) {
        fileList = event.dataTransfer.files // drop
      } else if (event.target && event.target.files) {
        fileList = event.target.files // input
      } else {
        ui.msgError(this, "Não foi possível obter os arquivos.")
        return
      }

      let newArrayValid = []
      const re = /(?:\.([^.]+))?$/;

      for (const file of fileList) {
        const ext = re.exec(file.name)[1]

        if (ext) {
          if (this.extensionAccepted.includes(ext.toLowerCase())) {
            const size_kb = file.size / 1000
            if (size_kb <= this.sizeMaxAcceptedKb) {
              newArrayValid.push(file)
            } else {
              ui.msgError(this, `Arquivo '${file.name}' possui tamanho superior ao máximo permitido de '${(this.sizeMaxAcceptedKb / 1000)}MB'.`)
            }
          } else {
            ui.msgError(this, `Arquivo '${file.name}' com extensão não aceita. Utilize somente uma das seguintes extensões: ${this.extensionAccepted.join(', ')}.`)
          }
        } else {
          ui.msgError(this, `Arquivo '${file.name}' com extensão não aceita. Utilize somente uma das seguintes extensões: ${this.extensionAccepted.join(', ')}.`)
        }
      }

      this.filesSelected = newArrayValid
      this.selectedFiles = newArrayValid

      this.uploadFiles(false)
    },

    async uploadFiles(byWebcam, specialTypeOpenDialog = true) {

      this.byWebcam = byWebcam

      if (this.selectedFiles && this.selectedFiles.length > 0) {

        if (this.selectedFiles.length <= this.maxFilesSend) {

          if (this.specialTypeEvidenceFile && specialTypeOpenDialog) {

            //Sempre irá abrir o dialogo até que tenha sido validado e deverá continuar
            this.$emit("onSpecialTypeEvidenceFileOpenDialog")

          } else {
            this.uploadFilesAux(byWebcam)
          }

        } else {

          ui.msgError(this, "Máximo de arquivos por vez excedido. Selecione somente até '" + this.maxFilesSend + "' por vez.")

        }

      } else {

        this.$refs.formInputFile.$el.click()
        this.showMessageSelectFiles = true

      }


    },

    uploadFilesAux(byWebcam) {

      this.message = "";
      this.status = "sending"
      this.listSend = []
      this.uploadSuccess = false

      for (let i = 0; i < this.selectedFiles.length; i++) {

        this.listSend[i] = {file: this.selectedFiles[i]}
        this.progressInfos[i] = {percentage: 0, fileName: this.selectedFiles[i].name, error: ""}

      }

      this.uploadNextFile(byWebcam, 0)

    },

    uploadNextFile(byWebcam, index) {

      if (index < this.listSend.length) {

        const file = this.listSend[index].file

        if (byWebcam) {

          const sizeTotal = file.size
          let chunks = Math.ceil(sizeTotal / this.slice_size)

          if (chunks < 0)
            chunks = 1

          this.uploadByChunks(byWebcam, index, 0, file.name, file.size, file.type, 1, chunks, file.content)

        } else {

          const reader = new FileReader();

          reader.onload = e => {

            const sizeTotal = e.target.result.length
            let chunks = Math.ceil(sizeTotal / this.slice_size)

            if (chunks < 0)
              chunks = 1

            this.uploadByChunks(byWebcam, index, 0, file.name, file.size, file.type, 1, chunks, e.target.result)

          }

          reader.readAsDataURL(file);

        }


      } else {

        //Finalizado geral

        this.status = ""
        this.selectedFiles = undefined
        this.uploadSuccess = true

        if (!byWebcam) {
          this.filesSelected = []
        }


        if (!this.hasError) {
          this.progressInfos = []
        }

        this.$emit('uploadComplete')

      }


    },


    async uploadByChunks(byWebcam, index, id, fileName, fileSize, fileType, chunk, chunks, fileReader) {


      if (chunk <= chunks) {

        const slice = this.slice_size
        let start = (chunk - 1) * slice
        const next_slice = start + slice
        const chunkFile = fileReader.slice(start, next_slice);

        const uploadChunk = {
          id,
          foreignKey: this.foreignKey,
          type: this.type,
          categoryUnique: this.categoryUnique,
          fileName,
          fileSize,
          fileType,
          chunk,
          chunks,
          file: chunkFile,
          subtitle: this.subtitle,
          categoryId: this.categoryId,
          otherForeignKey: this.otherForeignKey,
        }

        let objectSend

        if (this.specialTypeEvidenceFile) {
          //Utilizado de forma especial em evidencias

          objectSend = {
            typeEvidenceCategoryId: this.evidenceFileEntity.typeEvidenceCategoryId,
            typeEvidenceServiceId: this.evidenceFileEntity.typeEvidenceServiceId,
            typeEvidenceServiceNotFound: this.evidenceFileEntity.typeEvidenceServiceNotFound,
            typeEvidenceServiceNotFoundOther: this.evidenceFileEntity.typeEvidenceServiceNotFoundOther,
            typeEvidenceStatusId: this.evidenceFileEntity.typeEvidenceStatusId,
            environmentComplement: this.evidenceFileEntity.environmentComplement,
            uploadChunk
          }

        } else {
          //Por padrão será o próprio arquivo padrão
          objectSend = uploadChunk
        }


        //return this.post(path,uploadChunk)
        //uploadByChunks(this.path, id, this.foreignKey, this.type, fileName, fileSize, fileType, chunk, chunks, chunkFile, this.subtitle, this.categoryId, this.otherForeignKey)

        http.post(this.path, objectSend)
            .then(async (response) => {

              //this.message = "Enviando arquivo " + (index+1) + "/" + this.listSend.length //Necessário para forçar atualizações na listagem, onde é desejada
              this.progressInfos[index].percentage = Math.ceil((chunk / chunks) * 100)

              this.progressInfos.push({fileName: "refresh"}) //Forçar renderização do array
              this.progressInfos.pop() //Forçar renderização do array

              const responseId = response.data.body.id

              //Avança para próximo pedaço
              await this.uploadByChunks(byWebcam, index, responseId, fileName, fileSize, fileType, ++chunk, chunks, fileReader)

            })
            .catch((error) => {
              this.progressInfos[index].percentage = 0
              this.progressInfos[index].error = "Falhou por favor tente novamente"
              this.hasError = true

              ui.generalResponseError(this, error, () => {
                //Avança para próximo da fila, pois este arquivo já falhou
                this.uploadNextFile(byWebcam, ++index);
              })

            })


      } else {

        //Próximo da fila
        this.uploadNextFile(byWebcam, ++index);

      }


    },


  },
  mounted() {

    this.complementId = this.path.replaceAll("/", '_') + '-' + this.type + '-' + this.categoryUnique + '-' + this.foreignKey;


    if (this.type === "I" || this.type === "E") {
      this.typeImage = true
    }


    this.buttonText = "Enviar arquivos"

    if (this.typeImage) {
      this.buttonText = "Enviar imagens"
    }

    if (this.categoryUnique !== '') {
      this.buttonText = "Enviar " + this.detailUnique
    }

    if (this.maxSizeKB === 0) {

      if (this.type === "D") {
        this.sizeMaxAcceptedKb = 500000 //Padrão identico ao backend
      } else {
        this.sizeMaxAcceptedKb = 50000 //Padrão identico ao backend
      }

    } else {
      this.sizeMaxAcceptedKb = this.maxSizeKB //Outro limite desejado
    }

    if (this.extension && this.extension.length > 0) {
      //Extensão desejada fora do padrão
      this.extensionAccepted = this.extension
    } else {
      //Extensões do padrão

      if (this.type === "D") {
        this.extensionAccepted = ['jpg', 'jpeg', 'png', 'xlx', 'xlsx', 'xlxs', 'doc', 'docx', 'ppt', 'pptx', 'pdf', 'mp4', '3gpp']
      } else {
        this.extensionAccepted = ['jpg', 'jpeg', 'png']
      }

    }

  },
  watch: {
    continuedSubmit(value) {
      if (value)
        this.uploadFiles(this.byWebcam, false)
    }

  }
};
</script>
<style>
.flash-effect {

}
</style>